import React from "react";
import { useLang } from "../contexts/LanguageContext";
import ArticleListPage from "../components/ArticleListPage";

const IMAGES = {
  war_crime: "https://static.prod-images.emergentagent.com/jobs/be2064b9-9d7d-4260-b3d4-e04b780abb55/images/07d06b03700bad39a92b3777f5a8f0215faa452d7438dcc85358c0f56db0d3eb.png",
  terror_crime: "https://static.prod-images.emergentagent.com/jobs/be2064b9-9d7d-4260-b3d4-e04b780abb55/images/af3383f01b902e9c59eacfbaee9a4c68f6f87ee413498a382bce77842fa0897b.png",
  monitoring: "https://static.prod-images.emergentagent.com/jobs/be2064b9-9d7d-4260-b3d4-e04b780abb55/images/af3383f01b902e9c59eacfbaee9a4c68f6f87ee413498a382bce77842fa0897b.png",
  study: "https://static.prod-images.emergentagent.com/jobs/be2064b9-9d7d-4260-b3d4-e04b780abb55/images/d674fcde06ed8375649c122b40877b2edc71287780b0b40fbaaf78fac4093ff5.png",
  analysis: "https://images.unsplash.com/photo-1768213022263-0414dc145dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  news: "https://images.unsplash.com/photo-1758138258458-64ee0fbdef4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  director_message: "https://static.prod-images.emergentagent.com/jobs/be2064b9-9d7d-4260-b3d4-e04b780abb55/images/d674fcde06ed8375649c122b40877b2edc71287780b0b40fbaaf78fac4093ff5.png",
  publication: "https://images.unsplash.com/photo-1598420563273-df02d9118be7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export function WarCrimes() {
  const { t } = useLang();
  return <ArticleListPage testId="war-crimes-page" category="war_crime" eyebrow="Documentation" title={t.sections.war_crimes_title} subtitle={t.sections.war_crimes_sub} heroImage={IMAGES.war_crime} />;
}
export function TerrorCrimes() {
  const { t } = useLang();
  return <ArticleListPage testId="terror-crimes-page" category="terror_crime" eyebrow="Threat Actors" title={t.sections.terror_crimes_title} subtitle={t.sections.terror_crimes_sub} heroImage={IMAGES.terror_crime} />;
}
export function Monitoring() {
  const { t } = useLang();
  return <ArticleListPage testId="monitoring-page" category="monitoring" eyebrow="Field Monitoring" title={t.sections.monitoring_title} subtitle={t.sections.monitoring_sub} heroImage={IMAGES.monitoring} />;
}
export function Studies() {
  const { t } = useLang();
  return <ArticleListPage testId="studies-page" category="study" eyebrow="Research" title={t.sections.studies_title} subtitle={t.sections.studies_sub} heroImage={IMAGES.study} />;
}
export function Analysis() {
  const { t } = useLang();
  return <ArticleListPage testId="analysis-page" category="analysis" eyebrow="Analysis" title={t.sections.analysis_title} subtitle={t.sections.analysis_sub} heroImage={IMAGES.analysis} />;
}
export function News() {
  const { t } = useLang();
  return <ArticleListPage testId="news-page" category="news" eyebrow="News" title={t.sections.news_title} subtitle={t.sections.news_sub} heroImage={IMAGES.news} />;
}
export function Director() {
  const { t } = useLang();
  return <ArticleListPage testId="director-page" category="director_message" eyebrow="Director" title={t.sections.director_title} subtitle={t.sections.director_sub} heroImage={IMAGES.director_message} />;
}
export function Publications() {
  const { t } = useLang();
  return <ArticleListPage testId="publications-page" category="publication" eyebrow="Publications" title={t.sections.publications_title} subtitle={t.sections.publications_sub} heroImage={IMAGES.publication} />;
}
